/**
 * State radon programs & resources.
 * A curated set of well-known state radon program URLs + phone numbers.
 * When a state isn't listed here, a friendly EPA fallback is returned.
 */

const EPA_STATE_MAP =
  "https://www.epa.gov/radon/find-information-about-local-radon-zones-and-state-contact-information";

// Handful of highly-populated states hand-curated. All others fall back to EPA state map.
export const STATE_RADON_PROGRAMS = {
  PA: {
    name: "Pennsylvania",
    programName: "PA DEP Radon Division",
    url: "https://www.dep.pa.gov/Business/RadiationProtection/RadonDivision/Pages/default.aspx",
    phone: "1-800-237-2366",
    blurb: "Pennsylvania has some of the highest indoor radon levels in the country. The PA DEP Radon Division certifies testers/mitigators and offers homeowner resources.",
  },
  OH: {
    name: "Ohio",
    programName: "Ohio Department of Health — Radon Program",
    url: "https://odh.ohio.gov/know-our-programs/radon",
    phone: "1-800-523-4439",
    blurb: "Ohio DOH provides low-cost test kits and maintains a directory of certified radon-mitigation professionals.",
  },
  NY: {
    name: "New York",
    programName: "NYS DOH Radon Program",
    url: "https://www.health.ny.gov/environmental/radiological/radon/",
    phone: "1-518-402-7550",
    blurb: "The NYS DOH offers free test kits to residents of certain counties and lists certified mitigation contractors.",
  },
  IL: {
    name: "Illinois",
    programName: "IEMA Radon Program",
    url: "https://iema.illinois.gov/preparedness/radon.html",
    phone: "1-800-325-1245",
    blurb: "Illinois requires radon disclosure at real-estate transactions and certifies radon measurement/mitigation professionals.",
  },
  CA: {
    name: "California",
    programName: "CDPH Radon Program",
    url: "https://www.cdph.ca.gov/Programs/CEH/DRSEM/Pages/EMB/Radon/Radon.aspx",
    phone: "1-800-745-7236",
    blurb: "CA CDPH provides low-cost test kits and maintains a certified-professional directory.",
  },
  FL: {
    name: "Florida",
    programName: "Florida Radon Program",
    url: "https://www.floridahealth.gov/environmental-health/radon/",
    phone: "1-800-543-8279",
    blurb: "Florida DOH offers test kits and licenses radon-measurement and mitigation businesses.",
  },
  MI: {
    name: "Michigan",
    programName: "MI EGLE Indoor Radon Program",
    url: "https://www.michigan.gov/egle/about/organization/materials-management/radiological-protection/indoor-radon",
    phone: "1-800-723-6642",
    blurb: "Michigan EGLE offers free test kits during Radon Action Month (January) and coordinates outreach through local health departments.",
  },
  MN: {
    name: "Minnesota",
    programName: "MDH Radon Program",
    url: "https://www.health.state.mn.us/communities/environment/air/radon/index.html",
    phone: "1-651-201-4601",
    blurb: "Minnesota Department of Health has one of the strongest state radon programs, with disclosure laws and low-cost test kits.",
  },
  IA: {
    name: "Iowa",
    programName: "Iowa Radon Program",
    url: "https://hhs.iowa.gov/public-health/radon",
    phone: "1-800-383-5992",
    blurb: "Iowa has the highest average indoor radon level in the U.S. and offers free/discounted test kits.",
  },
  WI: {
    name: "Wisconsin",
    programName: "WI DHS Radon Program",
    url: "https://www.dhs.wisconsin.gov/radon/index.htm",
    phone: "1-888-569-7236",
    blurb: "Wisconsin DHS maintains a radon information network with regional centers offering test kits and support.",
  },
};

export function getStateProgram(state) {
  if (!state) return null;
  const key = String(state).toUpperCase();
  return STATE_RADON_PROGRAMS[key] || {
    name: key,
    programName: "EPA state contact list",
    url: EPA_STATE_MAP,
    phone: null,
    blurb: "We don't have a curated partner in this state yet. The EPA maintains a directory of every state radon program and how to reach them.",
  };
}
